export const CHECKOUT_URL = 'https://obesidad-en.impultienda.ar/checkout'

export const PRICE = '$27 USD'

export const MOCKUP_IMAGE =
  'https://cdn.magicpatterns.com/uploads/knGaimsCB4AaZ34NbFXgDx/OBESIDAD-EN.png'

export const AUTHOR_IMAGE =
  'https://cdn.magicpatterns.com/uploads/dp5rkSVj73CUET9THKdXCC/Dra_Karito_real.png'

export const heroStats = [
  { value: '+300', label: 'clinical tools ready to use' },
  { value: '+2,000', label: 'doctors already using the methodology' },
  { value: '6', label: 'specialized volumes' },
  { value: '100%', label: 'digital • instant download' },
]

export const beforeItems = [
  'You reviewed several guidelines before deciding what to do with a patient.',
  'You hesitated when choosing the most appropriate medication.',
  'You wasted time interpreting laboratory results and biomarkers.',
  'You improvised when a patient stopped responding to treatment.',
  'Patients abandoned treatment because they didn’t fully understand the process.',
  'You spent hours reviewing scientific articles before your next consultation.',
]

export const afterItems = [
  'Follow a step-by-step pathway that guides you through each stage of treatment.',
  'Make decisions using clinical algorithms based on the patient’s profile.',
  'Use organized tables and interpretation criteria for safer clinical decisions.',
  'Know when to adjust treatment, change strategies, or address a weight-loss plateau.',
  'Use patient education resources that improve adherence from the first consultation.',
  'Have the relevant evidence organized into one practical Clinical Pathway.',
]

export const painPoints = [
  {
    emoji: '😰',
    text: 'You have a patient with obesity sitting in front of you, and you’re not completely sure which treatment is most appropriate for their clinical profile.',
  },
  {
    emoji: '⏱️',
    text: 'You spend too much time checking guidelines, consensus statements, or research articles just to confirm a decision you need to make during the consultation.',
  },
  {
    emoji: '🤔',
    text: 'When a patient doesn’t respond to treatment, you’re unsure whether to increase the dose, switch medication, or change the overall strategy.',
  },
  {
    emoji: '📋',
    text: 'You want a clear methodology for evaluating every patient without forgetting an important test, criterion, or follow-up step.',
  },
  {
    emoji: '💬',
    text: 'Some patients abandon treatment because they don’t understand what to expect or lose motivation during follow-up.',
  },
  {
    emoji: '💉',
    text: 'You want greater confidence when prescribing medications such as semaglutide or tirzepatide, but still have questions about indications, titration, and monitoring.',
  },
]

export const volumes = [
  {
    tag: 'VOLUME 1',
    emoji: '📘',
    title: 'Master the Diagnosis from the Very First Consultation',
    text: 'Learn how to identify the patient’s clinical profile, determine the appropriate assessments, and establish a structured treatment plan from day one.',
    color: 'bg-navy',
  },
  {
    tag: 'VOLUME 2',
    emoji: '💊',
    title: 'Choose the Ideal Treatment with Confidence',
    text: 'Understand when to initiate pharmacological treatment, how to select the most appropriate medication, how to approach titration, and how to avoid common prescribing mistakes.',
    color: 'bg-forest-mid',
  },
  {
    tag: 'VOLUME 3',
    emoji: '🧪',
    title: 'Interpret Laboratory Results Like an Expert',
    text: 'Turn laboratory results into practical clinical decisions using organized tables, biomarkers, and evidence-based interpretation criteria.',
    color: 'bg-navy-soft',
  },
  {
    tag: 'VOLUME 4',
    emoji: '📈',
    title: 'Achieve Lasting Results Without Guesswork',
    text: 'Learn how to manage weight-loss plateaus, adjust treatment strategies, address adverse effects, and maintain long-term clinical progress.',
    color: 'bg-forest',
  },
  {
    tag: 'VOLUME 5',
    emoji: '🩺',
    title: 'Solve the Most Challenging Clinical Cases',
    text: 'Develop a structured approach to patients with diabetes, hypertension, insulin resistance, severe obesity, menopause, and other scenarios that create clinical uncertainty.',
    color: 'bg-navy-deep',
  },
  {
    tag: 'VOLUME 6',
    emoji: '🧰',
    title: 'Speed Up Your Consultations with Ready-to-Use Tools',
    text: 'Get checklists, algorithms, templates, tables, and visual resources designed to simplify your consultations and reduce decision-making time.',
    color: 'bg-forest-deep',
  },
]

export const deliverables = [
  {
    emoji: '📘',
    title: 'The 6 Volumes of the Clinical Pathway for Obesity Management',
    text: 'More than 300 algorithms, protocols, tables, and practical tools organized to help you address the most important decisions during your consultations.',
  },
  {
    emoji: '📋',
    title: 'Assessment, Prescribing & Follow-Up Checklists',
    text: 'Practical checklists designed to standardize your clinical workflow and help ensure important steps aren’t overlooked.',
  },
  {
    emoji: '💬',
    title: 'Patient Education Resources',
    text: 'Ready-to-use materials designed to help patients better understand their treatment and improve adherence.',
  },
  {
    emoji: '📱',
    title: 'Complete Digital Access',
    text: 'All materials delivered in PDF format, optimized for computer, tablet, and mobile use.',
  },
]

export const bonuses = [
  {
    tag: 'BONUS #1',
    emoji: '🧠',
    title: 'Clinical Decision Algorithm Kit',
    hook: 'Stop checking multiple guidelines before every consultation.',
    text: 'Visual, easy-to-follow algorithms that help you navigate key clinical decisions based on the patient’s scenario — from initial assessment and treatment selection to dose adjustments and follow-up.',
    bullets: [],
    value: '$37 USD',
    image: 'https://cdn.magicpatterns.com/uploads/16AXMLZHGCeMHykSrsMVAS/BONUS_1_OBESIDAD-EN.png',
  },
  {
    tag: 'BONUS #2',
    emoji: '💬',
    title: 'Medical Scripts for Improving Patient Adherence',
    hook: 'Know exactly what to say when patients hesitate, resist, or want to quit.',
    text: 'Practical conversation scripts for patients who:',
    bullets: [
      'Fear medications',
      'Are hesitant about injections',
      'Want to stop treatment',
      'Believe willpower alone is enough',
    ],
    value: '$37 USD',
    image: 'https://cdn.magicpatterns.com/uploads/vXRknz2sc37FU6j2e5ANvb/BONUS_2_OBESIDAD-EN.png',
  },
  {
    tag: 'BONUS #3',
    emoji: '✅',
    title: 'Professional Clinical Checklist Pack',
    hook: 'Standardize your consultation without relying on memory.',
    text: 'Make sure you don’t overlook:',
    bullets: [
      'Initial assessments',
      'Diagnostic criteria',
      'Pharmacological indications',
      'Treatment adjustments',
      'Monthly follow-up',
      'Annual monitoring',
    ],
    value: '$27 USD',
    image: 'https://cdn.magicpatterns.com/uploads/pq4vsgpLoNSUq2u1jSrLs7/BONUS_3_OBESIDAD-EN.png',
  },
  {
    tag: 'BONUS #4',
    emoji: '📋',
    title: 'Patient Education Template Pack',
    hook: 'Professional, ready-to-use materials you can print or share.',
    text: 'Help your patients understand:',
    bullets: [
      'How their treatment works',
      'What results to expect',
      'How to manage common side effects',
      'Which habits to maintain',
      'When to return for follow-up',
    ],
    value: '$47 USD',
    image: 'https://cdn.magicpatterns.com/uploads/oqVaffnckKNCC3qHvGwD6Z/BONUS_4_OBESIDAD-EN.png',
  },
  {
    tag: 'BONUS #5',
    emoji: '🩺',
    title: 'Step-by-Step Clinical Case Collection',
    hook: 'See the clinical reasoning behind challenging scenarios.',
    text: 'Includes cases involving:',
    bullets: [
      'Type 2 diabetes',
      'Menopause',
      'Insulin resistance',
      'Severe obesity',
      'Weight-loss plateaus',
      'Weight regain during or after treatment',
    ],
    value: '$37 USD',
    image: 'https://cdn.magicpatterns.com/uploads/4WCZgt6jrGAhEeDvVMo7of/BONUS_5_OBESIDAD-EN.png',
  },
]

export const offerRows = [
  { label: 'Clinical Kit for Obesity Management — 6 Volumes', value: '$97' },
  { label: 'Clinical Decision Algorithm Kit', value: '$37' },
  { label: 'Medical Scripts for Patient Adherence', value: '$37' },
  { label: 'Professional Clinical Checklist Pack', value: '$27' },
  { label: 'Patient Education Template Pack', value: '$47' },
  { label: 'Step-by-Step Clinical Case Collection', value: '$37' },
]

export const testimonials = [
  {
    quote:
      'Before discovering the Clinical Pathway, I spent far too much time searching for information before seeing patients with obesity. Now I follow the algorithms and feel much more confident in my decisions.',
    name: 'Dr. Maria P.',
    role: 'Family Medicine • Colombia 🇨🇴',
    image: 'https://cdn.magicpatterns.com/patterns/generated-images/bad30f95-262f-45a8-9415-bf1f8a36c0f3.jpg',
  },
  {
    quote:
      'Volume 2 completely changed the way I approach treatment selection. I now have a much clearer framework for deciding when to initiate pharmacological treatment and how to approach follow-up.',
    name: 'Dr. Roberto G.',
    role: 'Internal Medicine • Mexico 🇲🇽',
    image: 'https://cdn.magicpatterns.com/patterns/generated-images/8e896502-681c-4b54-9df7-59ac94644b3b.jpg',
  },
  {
    quote:
      'The checklists and clinical cases are the tools I use the most. They help me stay organized and make sure I don’t overlook important steps during the consultation.',
    name: 'Dr. Andrea L.',
    role: 'Endocrinology • Argentina 🇦🇷',
    image: 'https://cdn.magicpatterns.com/patterns/generated-images/05022984-808c-4066-b0cd-e1226ce6ff81.jpg',
  },
  {
    quote:
      'The adherence scripts made a huge difference. My patients understand their treatment much better, and I’m able to address their concerns much more effectively.',
    name: 'Dr. Jose V.',
    role: 'General Medicine • Spain 🇪🇸',
    image: 'https://cdn.magicpatterns.com/patterns/generated-images/6ee3f53e-df1b-46d9-a5a3-698ac34b4a2e.jpg',
  },
]

export const faqs = [
  {
    q: 'How will I receive the material?',
    a: 'Immediately after completing your purchase, you’ll receive an email with access to download all 6 Volumes and 5 Bonuses in PDF format.',
  },
  {
    q: 'Is the content suitable for doctors in different countries?',
    a: 'The material is written in English and based on international clinical evidence. However, always consider your country’s local guidelines, approved medications, prescribing requirements, and regulations.',
  },
  {
    q: 'Can I access it from my phone?',
    a: 'Yes. The PDFs are optimized for computer, tablet, and mobile devices, and can also be printed for use in your practice.',
  },
  {
    q: 'Is this a one-time payment?',
    a: 'Yes. You pay once and receive lifetime access to the material.',
  },
  {
    q: 'Do I need to be an obesity specialist?',
    a: 'No. The Clinical Pathway is designed as a practical decision-support resource for physicians who manage patients with obesity, whether they are general practitioners or specialists.',
  },
]

export const purchaseNotifications = [
  { name: 'Dr. Emily R.', place: 'Austin, United States' },
  { name: 'Dr. James O.', place: 'Manchester, United Kingdom' },
  { name: 'Dr. Priya S.', place: 'Toronto, Canada' },
  { name: 'Dr. Carlos M.', place: 'Monterrey, Mexico' },
  { name: 'Dr. Sarah K.', place: 'Melbourne, Australia' },
  { name: 'Dr. Daniel A.', place: 'Dublin, Ireland' },
  { name: 'Dr. Lucia F.', place: 'Madrid, Spain' },
  { name: 'Dr. Michael B.', place: 'Chicago, United States' },
  { name: 'Dr. Ana T.', place: 'Bogotá, Colombia' },
  { name: 'Dr. Nathan W.', place: 'Auckland, New Zealand' },
]
